import { render, staticRenderFns } from "./wulianwang.vue?vue&type=template&id=9d1a97ac&scoped=true&"
import script from "./wulianwang.vue?vue&type=script&lang=js&"
export * from "./wulianwang.vue?vue&type=script&lang=js&"
import style0 from "./wulianwang.vue?vue&type=style&index=0&id=9d1a97ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1a97ac",
  null
  
)

export default component.exports